import React, { useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import uploadsApi from '../../api/uploadsApi';

const AuthenticatedBackgroundImage = React.forwardRef(({ imageUrl, alt, sx, onError, onLoad, fit = 'cover', onMouseEnter, onMouseMove, onMouseLeave }, ref) => {
  const [backgroundUrl, setBackgroundUrl] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const fetchImageUrl = async () => {
      if (!imageUrl) {
        if (!isCancelled) {
          setBackgroundUrl('');
          setLoading(false);
        }
        return;
      }
      setLoading(true);
      try {
        const url = await uploadsApi.getSecureUrl(imageUrl);
        if (!isCancelled) {
          setBackgroundUrl(url);
        }
      } catch (error) {
        console.error(`Failed to get secure URL for background image ${imageUrl}`, error);
        if (!isCancelled && onError) {
          onError(error);
        }
      } finally {
        if (!isCancelled) {
          setLoading(false);
        }
      }
    };

    fetchImageUrl();

    return () => {
      isCancelled = true;
    };
  }, [imageUrl]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ...sx }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  return (
    <Box
      ref={ref}
      sx={{
        ...sx,
        backgroundImage: backgroundUrl ? `url(${backgroundUrl})` : 'none',
        backgroundSize: fit,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: backgroundUrl ? 'block' : 'none', // Hide if no image
      }}
      aria-label={alt}
      onLoad={onLoad}
      onMouseEnter={onMouseEnter}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    />
  );
});

export default React.memo(AuthenticatedBackgroundImage);